import React, { useEffect, useState } from "react";
import styles from "./CloseShiftModal.module.css";
import { API_URL } from "../../config/api";

const CloseShiftModal = ({ open, onClose, warehouse, onSuccess }) => {
  const [amount, setAmount] = useState("0");
  const [shiftId, setShiftId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !warehouse?.id) return;

    const fetchShift = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(
          `${API_URL}/api/shifts?status=active&storage_id=${warehouse.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        // если сервер вернул не JSON, чтобы не падать
        const text = await res.text();
        let data = null;
        try {
          data = JSON.parse(text);
        } catch {
          throw new Error(
            "Сервер вернул не JSON (возможно неверный API_URL/proxy или истёк токен)."
          );
        }

        if (!res.ok) {
          throw new Error(data?.message || "Ошибка получения активной смены");
        }

        const activeShift = data?.data?.[0];
        if (!activeShift) {
          alert("Активная смена не найдена");
          onClose();
          return;
        }

        setShiftId(activeShift.id);
      } catch (e) {
        alert(e.message);
        onClose();
      }
    };

    fetchShift();
  }, [open, warehouse, onClose]);

  const handleKeyClick = (val) => {
    if (val === "C") {
      setAmount("0");
      return;
    }

    if (val === "." && amount.includes(".")) return;

    setAmount((prev) => (prev === "0" ? val : prev + val));
  };

  const closeShift = async (exit = false) => {
    if (!shiftId) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      // ВАЖНО: тут тоже API_URL, иначе часто прилетает index.html
      const res = await fetch(`${API_URL}/api/shifts/${shiftId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify({
          cash_balance: Number(amount),
          status: "closed",
        }),
      });

      // безопасно читаем ответ
      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        // если вдруг пришел HTML
        throw new Error(
          "Сервер вернул HTML вместо JSON. Проверь API_URL/proxy и авторизацию (token)."
        );
      }

      if (!res.ok) {
        throw new Error(data?.message || "Ошибка закрытия смены");
      }

      if (onSuccess) onSuccess();
      onClose();

      if (exit) {
        localStorage.clear();
        window.location.reload();
      }
    } catch (e) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // если хочешь — можно еще сбросить сумму
    // setAmount("0");
    onClose();
  };

  if (!open) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Закрыть смену</h2>

        <p>
          <strong>Склад:</strong> {warehouse?.name}
        </p>

        <p className={styles.subText}>Введите остаток наличных в кассе</p>

        <div className={styles.amountDisplay}>{amount} ₸</div>

        <div className={styles.numPad}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0].map((n) => (
            <button key={n} onClick={() => handleKeyClick(n.toString())}>
              {n}
            </button>
          ))}
          <button
            className={styles.clearBtn}
            onClick={() => handleKeyClick("C")}
          >
            C
          </button>
        </div>

        <div className={styles.modalActions}>
          <button
            className={styles.exit}
            onClick={() => closeShift(true)}
            disabled={loading}
          >
            Закрыть и выйти
          </button>

          <button
            className={styles.confirm}
            onClick={() => closeShift(false)}
            disabled={loading}
          >
            Закрыть смену
          </button>
        </div>

        {/* Кнопка ОТМЕНЫ снизу */}
        <button
          className={styles.cancel}
          onClick={handleCancel}
          disabled={loading}
        >
          Отмена
        </button>
      </div>
    </div>
  );
};

export default CloseShiftModal;
